export default {
  'app.settings.menuMap.basic': 'Ustawienia',
  'app.settings.menuMap.security': 'Ustawienia bezpieczeństwa',
  'app.settings.menuMap.binding': 'Account Binding',
  'app.settings.menuMap.notification': 'Nowa wiadomość - powiadomienie',
  'app.settings.basic.avatar': 'Avatar',
  'app.settings.basic.change-avatar': 'Zmień avatar',
  'app.settings.basic.email': 'Email',
  'app.settings.basic.email-message': 'Wprowadź adres email!',
  'app.settings.basic.nickname': 'Nickname',
  'app.settings.basic.nickname-message': 'Wprowadź nickname!',
  'app.settings.basic.profile': 'Profil osobisty',
  'app.settings.basic.profile-message': 'Wprowadź profil osobisty!',
  'app.settings.basic.profile-placeholder': 'Krótkie wprowadzenie',
  'app.settings.basic.country': 'Kraj/Region',
  'app.settings.basic.country-message': 'Wprowadź kraj!',
  'app.settings.basic.geographic': 'Województwo/Miasto',
  'app.settings.basic.geographic-message': 'Wprowadź województwo/miasto!',
  'app.settings.basic.address': 'Ulica',
  'app.settings.basic.address-message': 'Wprowadź ulicę!',
  'app.settings.basic.phone': 'Numer telefonu',
  'app.settings.basic.phone-message': 'Wprowadź numer telefonu!',
  'app.settings.basic.update': 'Zaktualizuj informacje',
  'app.settings.security.strong': 'Silne',
  'app.settings.security.medium': 'Średnie',
  'app.settings.security.weak': 'Słabe',
  'app.settings.security.password': 'Hasło',
  'app.settings.security.password-description': 'Siła hasła:',
  'app.settings.security.phone': 'Telefon bezpieczeństwa',
  'app.settings.security.phone-description': 'Przypisz numer telefonu',
  'app.settings.security.question': 'Pytanie bezpieczeństwa',
  'app.settings.security.question-description': 'Pytanie bezpieczeństwa nie jest ustawione',
  'app.settings.security.email': 'Zapasowy email',
  'app.settings.security.email-description': 'Przypisz zapasowy email',
  'app.settings.security.mfa': 'Urządzenie MFA',
  'app.settings.security.mfa-description':
    'Nieprzypisane urządzenie MFA, po przypisaniu, można potwierdzić dwukrotnie ',
  'app.settings.security.modify': 'Modyfikuj',
  'app.settings.security.set': 'Ustaw',
  'app.settings.security.bind': 'Przypisz',
  'app.settings.binding.taobao': 'Przypisz Taobao',
  'app.settings.binding.taobao-description': 'Aktualnie nieprzypisane konto Taobao',
  'app.settings.binding.alipay': 'Przypisz Alipay',
  'app.settings.binding.alipay-description': 'Aktualnie nieprzypisane konto Alipay',
  'app.settings.binding.dingding': 'Przypisz DingTalk',
  'app.settings.binding.dingding-description': 'Aktualnie nieprzypisane konto DingTal',
  'app.settings.binding.bind': 'Przypisz',
  'app.settings.notification.password': 'Hasło',
  'app.settings.notification.password-description':
    'Wiadomości od innych użytkowników będą powiadamiane w formie station letter',
  'app.settings.notification.messages': 'Wiadomości systemowe',
  'app.settings.notification.messages-description':
    'Wiadomości systemowe będą powiadamiane w formie station letter',
  'app.settings.notification.todo': 'Powiadomienie to-do',
  'app.settings.notification.todo-description':
    'Wiadomości to-do będą powiadamiane w formie station letter',
  'app.settings.open': 'Otwórz',
  'app.settings.close': 'Zamknij',
};
